import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ShopSettings = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState(false);
    const [popup1, setPopup1] = useState(false);
    const [popup2, setPopup2] = useState(false);
    const [popup3, setPopup3] = useState(false);
    const [popup4, setPopup4] = useState(false);
    const [settingId, setSettingId] = useState(null);
    const [referalAmount, setReferalAmount] = useState("");
    const [empOverloadCount, setEmpOverloadCount] = useState("");
    const [coupunamount, setCouponAmount] = useState("");
    const [amountperbooking, setAmountperbooking] = useState("");
    const [pointsperbooking, setPointsperbooking] = useState("");
    const [settings, setSettings] = useState({
      multiple_token: false,
      emp_overload_booking: false,
      membership: false,
      coupon: false,
      referal: false,
      employee_assigning: false,
      cash_online: false,
      cash_at_venue: false,
      membership_cash_online: false,
      membership_cashat_venue: false,
      emp_overload_count: null,
      referal_amount_per_point: null,
      coupon_selling_amount: null,
      customer_review:null,
    });
  
    useEffect(() => {
        fetchShopSettings(); // Fetch settings when the component mounts
      }, []);

    const fetchShopSettings = async () => {
      const token = localStorage.getItem("token");
      try {
        setLoading(true); // Start loading
        const response = await axios.get(`${var_api}/api/shop-settings/get`, {
          headers: {
            Authorization: `${token}`
          }
        });
  
        // Close popups
        setPopup(false);
        setPopup1(false);
        setSettingId(response.data.id);
        setSettings({
          multiple_token: response.data.multiple_token === 1,
          emp_overload_booking: response.data.emp_overload_booking === 1,
          membership: response.data.membership === 1,
          coupon: response.data.coupon === 1,
          referal: response.data.referal === 1,
          employee_assigning: response.data.employee_assigning === 1,
          cash_online: response.data.cash_online === 1,
          cash_at_venue: response.data.cash_at_venue === 1,
          membership_cash_online: response.data.membership_cash_online === 1,
          membership_cashat_venue: response.data.membership_cashat_venue === 1,
          emp_overload_count: response.data.emp_overload_count,
          referal_amount_per_point: response.data.referal_amount_per_point,
          coupon_selling_amount: response.data.coupon_selling_amount,
          amount_per_booking: response.data.amount_per_booking,
          points_per_booking: response.data.points_per_booking,
          customer_review: response.data.customer_review === 1,
        });
  
        // Store settings in localStorage
        localStorage.setItem("multiple_token", response.data.multiple_token);
        localStorage.setItem("emp_overload_booking", response.data.emp_overload_booking);
        localStorage.setItem("membership", response.data.membership);
        localStorage.setItem("coupon", response.data.coupon);
        localStorage.setItem("referal", response.data.referal);
        localStorage.setItem("employee_assigning", response.data.employee_assigning);
        localStorage.setItem("cash_online", response.data.cash_online);
        localStorage.setItem("cash_at_venue", response.data.cash_at_venue);
        localStorage.setItem("membership_cash_online", response.data.membership_cash_online);
        localStorage.setItem("membership_cashat_venue", response.data.membership_cashat_venue);
        localStorage.setItem("coupon_selling_amount", response.data.coupon_selling_amount);
        localStorage.setItem("customer_review", response.data.customer_review);
  
        setLoading(false); // Stop loading
      } catch (error) {
        setLoading(false); // Stop loading
        Swal.fire({
          title: "Error!",
          text: "Error fetching shop settings",
          icon: "error",
          confirmButtonColor: "#34c38f"
        });
        console.error("Error fetching shop settings:", error);
      }
    };
  
    const handleCheckboxChange = (field) => {
        const newValue = !settings[field];
        setSettings((prevSettings) => ({
          ...prevSettings,
          [field]: newValue
        }));
        updateShopSettings(field, newValue); // Call the API update after setting the new value
      };

  const updateShopSettings = async (field, value) => {
    const token = localStorage.getItem("token");
    try {
      const updatedValue = value ? 1 : 0; // Convert boolean to 1 or 0
      const payload = { [field]: updatedValue };

      await axios.put(`${var_api}/api/shop-settings/put/${settingId}`, payload, {
        headers: {
          Authorization: `${token}`
        }
      });

      // Update the local state to reflect the new value
      setSettings((prevSettings) => ({
        ...prevSettings,
        [field]: value
      }));
      fetchShopSettings();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: `Error updating ${field} setting`,
        icon: "error",
        confirmButtonColor: "#34c38f"
      });
      console.error(`Error updating ${field} setting:`, error);
    }
  };

  const updateShopSettingsPrice = async (field, value) => {
    const token = localStorage.getItem("token");
    try {
      const payload = { [field]: value };

      await axios.put(`${var_api}/api/shop-settings/put/${settingId}`, payload, {
        headers: {
          Authorization: `${token}`
        }
      });

      // Update local state after successful API call
      setSettings((prevSettings) => ({
        ...prevSettings,
        [field]: value
      }));
      fetchShopSettings();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: `Error updating ${field} setting`,
        icon: "error",
        confirmButtonColor: "#34c38f"
      });
      console.error(`Error updating ${field} setting:`, error);
    }
  };

  const handleGoToHome = () => {
    history.push('/sb-home');
  }

    return (
    <>
    {loading && <Loader />} 
     <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
      Shop Setting
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome}  style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
<Row className="justify-content-center">
  <Col lg={5} md={12}>
    <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px", marginTop:"20px" }}>
      <br />
      <Form>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Multiple Token</span>
          <Form.Check
            type="switch"
            id="multiple_token"
            checked={settings.multiple_token}
            onChange={() => handleCheckboxChange("multiple_token")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Employee Assigning Status</span>
          <Form.Check
            type="switch"
            id="employee_assigning"
            checked={settings.employee_assigning}
            onChange={() => handleCheckboxChange("employee_assigning")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span>Employee Overload Booking </span>
            {settings.emp_overload_booking && (
                <i className="bi bi-pencil-square" style={{color:"blue"}} onClick={() => setPopup1(true)}></i>
            )}
            <br />
            <small>(count: {settings.emp_overload_count})</small>
          </div>
          <Form.Check
            type="switch"
            id="emp_overload_booking"
            checked={settings.emp_overload_booking}
            onChange={() => handleCheckboxChange("emp_overload_booking")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Membership</span>
          <Form.Check
            type="switch"
            id="membership"
            checked={settings.membership}
            onChange={() => handleCheckboxChange("membership")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Coupon</span>
          <Form.Check
            type="switch"
            id="coupon"
            checked={settings.coupon}
            onChange={() => handleCheckboxChange("coupon")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span>Referal </span>
            {settings.referal && (
                <i className="bi bi-pencil-square" style={{color:"blue"}} onClick={() => setPopup(true)}></i>
            )}
            <br />
            <small>(Amount: {settings.referal_amount_per_point})</small>
          </div>
          <Form.Check
            type="switch"
            id="referal"
            checked={settings.referal}
            onChange={() => handleCheckboxChange("referal")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Pay Online</span>
          <Form.Check
            type="switch"
            id="cash_online"
            checked={settings.cash_online}
            onChange={() => handleCheckboxChange("cash_online")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Pay at Venue</span>
          <Form.Check
            type="switch"
            id="cash_at_venue"
            checked={settings.cash_at_venue}
            onChange={() => handleCheckboxChange("cash_at_venue")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Membership Pay Online</span>
          <Form.Check
            type="switch"
            id="membership_cash_online"
            checked={settings.membership_cash_online}
            onChange={() => handleCheckboxChange("membership_cash_online")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Membership Pay Venue</span>
          <Form.Check
            type="switch"
            id="membership_cashat_venue"
            checked={settings.membership_cashat_venue}
            onChange={() => handleCheckboxChange("membership_cashat_venue")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span>Coupon Selling Amount </span>
              {(settings.coupon_selling_amount !== null) && (
                <i className="bi bi-pencil-square" style={{ color: "blue" }} onClick={() => setPopup2(true)}></i>
              )}
            <br />
            <small>(Amount: {settings.coupon_selling_amount || 0})</small>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span>Amount per Booking </span>
              {(settings.amount_per_booking !== null) && (
                <i className="bi bi-pencil-square" style={{ color: "blue" }} onClick={() => setPopup3(true)}></i>
              )}
            <br />
            <small>(Amount: {settings.amount_per_booking || 0})</small>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <span>Points per Booking </span>
              {(settings.points_per_booking !== null) && (
                <i className="bi bi-pencil-square" style={{ color: "blue" }} onClick={() => setPopup4(true)}></i>
              )}
            <br />
            <small>(Amount: {settings.points_per_booking || 0})</small>
          </div>
        </div>
        
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span>Customer Review</span>
          <Form.Check
            type="switch"
            id="customer_review"
            checked={settings.customer_review}
            onChange={() => handleCheckboxChange("customer_review")}
          />
        </div>
      </Form>
    </Card>
  </Col>
</Row>


      {/* Modal for Referral Amount */}
      <Modal show={popup} onHide={() => setPopup(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Referral Point Value</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Referral Amount</Form.Label>
            <Form.Control
              type="text"
              placeholder="Change Amount"
              value={referalAmount}
              onChange={(e) => setReferalAmount(e.target.value)}
            />
          </Form.Group>
          <br/>
          <Button variant="dark" onClick={() => {
              updateShopSettingsPrice("referal_amount_per_point", referalAmount);
              setPopup(false); // Close the modal
            }}>
            Change Amount
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal for Employee Overload Count */}
      <Modal show={popup1} onHide={() => setPopup1(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Employee Overload Count</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Employee Overload Count</Form.Label>
            <Form.Control
              type="text"
              placeholder="Change Count"
              value={empOverloadCount}
              onChange={(e) => setEmpOverloadCount(e.target.value)}
            />
          </Form.Group>
          <br/>
          <Button variant="dark" onClick={() => {
              updateShopSettingsPrice("emp_overload_count", empOverloadCount);
              setPopup1(false); // Close the modal
            }}>
            Change Count
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal for coupon Selling amount */}
      <Modal show={popup2} onHide={() => setPopup2(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Coupon Selling Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Coupon Selling Amount</Form.Label>
            <Form.Control
              type="text"
              placeholder="Change Count"
              value={coupunamount}
              onChange={(e) => setCouponAmount(e.target.value)}
            />
          </Form.Group>
          <br/>
          <Button variant="dark" onClick={() => {
              updateShopSettingsPrice("coupon_selling_amount", coupunamount);
              setPopup2(false); // Close the modal
            }}>
            Change Count
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal for Amount Per Booking */}
      <Modal show={popup3} onHide={() => setPopup3(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Amount Per Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Amount Per Booking</Form.Label>
            <Form.Control
              type="text"
              placeholder="Change Count"
              value={amountperbooking}
              onChange={(e) => setAmountperbooking(e.target.value)}
            />
          </Form.Group>
          <br/>
          <Button variant="dark" onClick={() => {
              updateShopSettingsPrice("amount_per_booking", amountperbooking);
              setPopup3(false); // Close the modal
            }}>
            Change Count
          </Button>
        </Modal.Body>
      </Modal>

       {/* Modal for Points per booking */}
       <Modal show={popup4} onHide={() => setPopup4(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Points per Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Points Per Booking</Form.Label>
            <Form.Control
              type="text"
              placeholder="Change Count"
              value={pointsperbooking}
              onChange={(e) => setPointsperbooking(e.target.value)}
            />
          </Form.Group>
          <br/>
          <Button variant="dark" onClick={() => {
              updateShopSettingsPrice("points_per_booking", pointsperbooking);
              setPopup4(false); // Close the modal
            }}>
            Change Count
          </Button>
        </Modal.Body>
      </Modal>
    </>
    );
};

export default ShopSettings;